let configCache: any = null;
let configPromise: Promise<any> | null = null;

// Allow override via env variable for development
const configUrl = process.env.NEXT_PUBLIC_BASE_URL || '/api/config';

export async function getRuntimeConfig() {
    if (configCache) {
        return configCache;
    }

    // Prefer the config inlined into the initial HTML by layout.tsx — reading
    // it is synchronous, so startup (token init, first API call) no longer
    // waits on a POST /api/config round-trip. The fetch below remains as a
    // fallback for HTML rendered before this was introduced.
    if (typeof window !== "undefined" && (window as any).__RUNTIME_CONFIG__) {
        configCache = (window as any).__RUNTIME_CONFIG__;
        return configCache;
    }

    if (configPromise) {
        return await configPromise;
    }

    configPromise = fetch(configUrl, { method: 'POST' })
        .then(res => {
            if (!res.ok) {
                throw new Error("Failed to load runtime config");
            }
            return res.json();
        })
        .then(config => {
            configCache = config;
            return config;
        })
        .catch(error => {
            console.error("Error fetching runtime config:", error);
            configCache = null;
            configPromise = null; // Reset promise on error
            throw error; // Re-throw the error to be handled by the caller
        });

    return await configPromise;
}